import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconPossibleAliases: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <path
        d="M8.19356 9.49996V12.5H9.10992C9.86906 12.5 10.2299 13.0001 10.2299 14C10.2299 14.5001 9.86906 15 9.10992 15H8.19356V17M8.19356 9.49996H10.2299L10.2554 9.34995C10.2554 8.60436 10.8708 7.99995 11.6299 7.99995C12.3891 7.99995 13.0045 8.60436 13.0045 9.34995V9.79996H15.0663V17H8.19356M8.19356 9.49996H5.64819V10.9333C5.64819 11.7065 4.82542 12 4.06628 12C3.30715 12 2.8991 11.7065 2.8991 10.9333V9.49996H1.06637M8.19356 9.49996V7.49994L7.24325 7.50003C6.456 7.50003 5.8178 6.89561 5.8178 6.15002C5.8178 5.40443 6.456 4.80001 7.24325 4.80001H8.19356V3H1.06628L1.06637 9.49996M8.19356 17H1.06637V9.49996"
        stroke="#2B2C32"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M15.6494 1.88555L13.7441 1.18593L11.9324 0.520662L11.4334 1.87947L11.1315 1.7686C10.6312 1.58489 10.0767 1.84154 9.89296 2.34184C9.70925 2.84214 9.9659 3.39664 10.4662 3.58035L10.7682 3.69122L10.2692 5.05004L12.081 5.7153L12.3027 5.11139C12.4864 4.61109 13.0409 4.35444 13.5412 4.53814C14.0415 4.72185 14.2982 5.27635 14.1145 5.77665L13.8927 6.38057L15.3079 7.0899L17.13 2.34166L15.5559 1.85119"
        stroke="#262626"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
